import { Badge } from '@chakra-ui/react';
import React from 'react';

interface LegendBadgeProps {
  color: string;
}
export const LegendBadge: React.FC<LegendBadgeProps> = ({ color }) => {
  return (
    <Badge
      backgroundColor={color}
      w={4}
      h={4}
      alignSelf="center"
      mr={2}
      border="1px"
      borderColor="black"
    />
  );
};

interface StripedLegendBadgeProps {
  color: string;
}

export const StripedLegendBadge: React.FC<StripedLegendBadgeProps> = ({
  color,
}) => {
  const getRGBValues = (color: string) => {
    const tempElement = document.createElement('div');
    tempElement.style.color = color;
    document.body.appendChild(tempElement);
    const computedColor = window.getComputedStyle(tempElement).color;
    document.body.removeChild(tempElement);
    return computedColor.match(/\d+/g)?.map(Number) || [0, 0, 0];
  };

  const [r, g, b] = getRGBValues(color);

  const stripePattern = `repeating-linear-gradient(
    45deg,
    rgba(${r}, ${g}, ${b}, 0.5),
    rgba(${r}, ${g}, ${b}, 0.5) 5px,
    rgba(${r}, ${g}, ${b}, 0.25) 5px,
    rgba(${r}, ${g}, ${b}, 0.25) 10px
  )`;

  return (
    <Badge background={stripePattern} w={4} h={4} alignSelf="center" mr={2} />
  );
};
